import React from 'react'
import { Card, CardContent, CardHeader, CardSizeTypes } from '@digicert/dcone-common-ui'
import styles from './LicenseCard.module.scss'
import { Translate } from 'react-localize-redux'
import { LicenseCardProps } from './LicenseCard.types'
import { translate } from '../../../shared/helpers/utils'

export const LicenseCard = (
  {
    data,
    title
  }: LicenseCardProps) => {
  if(data) {
    return (
      <Card
        className={styles.card}
        size={CardSizeTypes.LARGE}
        header={<CardHeader label={title}/>}
        content={
          <CardContent>
            <div className={styles.rowHeader}>
              <p><Translate id='common.form.licenseType'/></p>
              <p><Translate id='common.form.quantity'/></p>
            </div>
            {data.map((item, index) => {
              return (
                <div key={index} className={styles.row}>
                  <p>{item.licenseType}</p>
                  <p>{item.quantity === -1 ? translate('common.form.unlimited') as string: item.quantity}</p>
                </div>
              )
            })}
          </CardContent>
        }
      />
    )
  }
  return (<></>)
}
